import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showUsers, showListings } from '../../../../ducks/SdkDataAccessLayer.duck';
import { addMarketplaceEntities } from '../../../../ducks/marketplaceData.duck';
import { getContent } from './helpers';
import { types as sdkTypes } from '../../../../util/sdkLoader';

const { UUID } = sdkTypes;

export const usePublicEventContent = item => {
    const [publicEventContent, setPublicEventContent] = useState(null);

    const allListings = useSelector(s => s.marketplaceData.entities.listing || {});
    const allUsers = useSelector(s => s.marketplaceData.entities.user || {});
    const allImages = useSelector(s => s.marketplaceData.entities.image || {});

    const dispatch = useDispatch();

    const requestListing = async id => {
        if (allListings[id]) {
            return allListings[id];
        }
        try {
            const entity = await dispatch(showListings({ id }));
            dispatch(addMarketplaceEntities(entity));
            return entity?.data?.data;
        } catch (e) {
            return null;
        }
    };

    const requestUser = async userId => {
        if (allUsers[userId]) {
            return allUsers[userId];
        }
        try {
            const id = new UUID(userId);
            const entity = await dispatch(
                showUsers({
                    id,
                    include: ['profileImage', 'createdAt'],
                    'fields.image': ['variants.square-small', 'variants.square-small2x'],
                })
            );
            dispatch(addMarketplaceEntities(entity));
            return entity?.data?.data;
        } catch (e) {
            return null;
        }
    };

    const requestContentData = async ({ horseownerId, riderId, listingId }) => {
        /**
         * the requests do not depend on each other and never reject
         * (a failed one resolves to null), so they are run in parallel
         */
        const [rider, horseowner, listing] = await Promise.all([
            requestUser(riderId),
            requestUser(horseownerId),
            requestListing(listingId),
        ]);

        const content = getContent({
            type: item.type,
            horseowner,
            rider: {
                ...(rider || {}),
                attributes: {
                    ...(rider?.attributes || {}),
                    profileImage: allImages[rider?.relationships?.profileImage?.data?.id?.uuid],
                },
            },
            listing,
        });

        setPublicEventContent(content);
    };

    useEffect(() => {
        const { listing, horseowner, rider } = item || {};

        requestContentData({
            horseownerId: horseowner?.id?.uuid,
            riderId: rider?.id?.uuid,
            listingId: listing?.id?.uuid,
        });
    }, [item.id]);

    return publicEventContent;
};
